<template>
  <NodeEditorial v-if="node" v-bind="node" />
</template>

<script lang="ts" setup>
defineOptions({
  name: 'PageHome',
})

definePageMeta({
  name: 'home',
  hideBreadcrumb: true,
  hidePageTitle: true,
})

const { entity: node, metatags } = await useDrupalRouteQuery('editorial')

/* eslint-disable  @typescript-eslint/no-explicit-any */
useLogo().setLogoThemeFragment(node as any)
// The generic type V for the fragment can't be made compatible with these
// argument type, which is why we have to cast is as any here (which is fine).
/* eslint-disable  @typescript-eslint/no-explicit-any */
usePageTracking(node as any, metatags)
/* eslint-disable  @typescript-eslint/no-explicit-any */
setActiveChannel(node as any)

await renderPageDependencies()
</script>
